export const INT_REGEX = /^[0-9]*?$/
export const CONFIRM_CODE_REGEX = /^[0-9]{6}$/
export const DOUBLE_REGEX = /^[0-9]*([,]|[,]([0-9]|[0-9][0-9]))?$/
export const SLUG_REGEX = /^[a-z0-9.]*$/

export const PHONE_REGEX = /^(\(?(\+|00)?\d{2}\)?)?\d{9}$/
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const POST_CODE_REGEX = /^[0-9]{2}-[0-9]{3}$/i
